import Swiper from 'swiper';

const gemeinschaftsraumSingle = function () {
  console.log('hello from gemeinschaftsraum-single');

  setTimeout(function () {
    setupGemeinschaftsraumSwiper();
  }, 50);

  function setupGemeinschaftsraumSwiper() {
    if ($('.swiper-container.gemeinschaftsraum').length) {
      console.log('swiper exists');
      // Swiper on top
      let swiper = new Swiper('.swiper-container.gemeinschaftsraum', {
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        init: true,
        autoplay: {
          delay: 3000,
        },
        lazy: {
          loadPrevNext: true,
        },
      });

      swiper.update();
    }
  }
};

export default gemeinschaftsraumSingle;



// WEBPACK FOOTER //
// ./scripts/barba-views/gemeinschaftsraum-single.js